import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownSelect, SelectItem, Tooltip } from '@dixa/lib-shared-habla';
import intersectionWith from 'lodash/intersectionWith';
import { useEffect, useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { analytics } from 'app/utils/segment';
import { languages } from 'app/utils/supportedLanguages';
import { satisfactionActions } from 'components/conversation/actions/satisfaction';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { useCurrentUser } from 'utils/user';
const defaultLanguage = 'en';
export const ConversationHeaderCsatDropdown = ({ disabledText, }) => {
    const dispatch = useAppDispatch();
    const [{ initial_channel: channel, attributes, id, direction }, languageCodes = [], asyncStatus,] = useAppSelector((state) => [
        state.conversation.metaConversation.conversation,
        state.conversation.availableSatisfactionLanguages,
        state.conversation.asyncStatus.availableSatisfactionLanguages,
    ], shallowEqual);
    const { currentRole: { atLeastAdmin }, } = useCurrentUser();
    const contactPoint = useMemo(() => {
        if (channel === 'email' || channel === 'contactform') {
            return attributes === null || attributes === void 0 ? void 0 : attributes.integration_email;
        }
        if (channel == 'pstnphone') {
            if (direction == 'outbound') {
                return attributes === null || attributes === void 0 ? void 0 : attributes.calling_number;
            }
            return attributes === null || attributes === void 0 ? void 0 : attributes.called_number;
        }
        if (channel == 'callback') {
            attributes === null || attributes === void 0 ? void 0 : attributes.callback_number;
        }
        return undefined;
    }, [attributes, channel]);
    useEffect(() => {
        if (channel && contactPoint) {
            bindActionToPromise(dispatch, satisfactionActions.getAvailableSatisfactionLanguagesRequest)({ channel, contactPoint });
        }
    }, [dispatch, channel, contactPoint]);
    const languageCodeItems = useMemo(() => {
        const availableLanguages = intersectionWith(languages, languageCodes, (a, b) => a.code === b);
        return availableLanguages.map(({ code, label }) => ({
            id: code,
            name: label,
            description: code,
        }));
    }, [languageCodes]);
    const isCancellable = channel === 'email' || channel === 'contactform';
    const selectedLanguage = useMemo(() => {
        if ((attributes === null || attributes === void 0 ? void 0 : attributes.language) &&
            languageCodes.includes(attributes.language)) {
            return attributes.language;
        }
        if (languageCodes.includes(defaultLanguage)) {
            return defaultLanguage;
        }
        return undefined;
    }, [languageCodes, attributes === null || attributes === void 0 ? void 0 : attributes.language]);
    const handleLanguageSelect = ({ id: languageCode }) => {
        analytics.conversationCsatMenuLanguageSelected({
            languageCode,
        });
        bindActionToPromise(dispatch, satisfactionActions.changeSatisfactionLanguageRequest)({ csid: id, language: languageCode });
    };
    const handleCancelCsat = () => {
        analytics.conversationCsatMenuCancelOptionClicked();
        bindActionToPromise(dispatch, satisfactionActions.cancelSatisfactionRequest)({ csid: id });
    };
    return (_jsx(Tooltip, Object.assign({ disabled: !!disabledText, content: "CSAT - Customer Satisfaction", dark: true }, { children: _jsx(DropdownSelect, Object.assign({ buttonProps: {
                icon: 'smile',
                disabled: !!disabledText,
                isLoading: asyncStatus === 'loading',
                variant: 'tertiary',
            }, items: languageCodeItems, itemComponent: SelectItem, selectedItems: selectedLanguage ? [selectedLanguage] : [], onSelect: handleLanguageSelect, onClear: atLeastAdmin && isCancellable ? handleCancelCsat : undefined, onClearText: "Cancel CSAT", onToggle: (isOpen) => {
                if (isOpen) {
                    analytics.conversationCsatMenuOpened();
                }
            } }, { children: disabledText || selectedLanguage })) })));
};
